<template>
    <img class="thumbnail__foreground-logo"
         :srcset="`${getForegroundLogo().x1} 1x, ${getForegroundLogo().x2} 2x`"
         :src="getForegroundLogo().x1"
         alt=""
         v-if="getForegroundLogo()"
    />
</template>

<script>
export default {
    name: 'thumbnail-foreground-logo',
    props: {
        course: {
            type: Object,
            required: true
        }
    },
    methods: {
        getForegroundLogo () {
            if (this.course.thumbnailOptions?.useForegroundLogo && this.course.thumbnail.foregroundLogoUrl !== null && this.course.thumbnail.foregroundLogoUrl !== undefined) {
                return {
                    x1: this.course.thumbnail.foregroundLogoUrl.x1,
                    x2: this.course.thumbnail.foregroundLogoUrl.x2
                }
            }

            return false
        }
    }
}
</script>

<style lang="scss" scoped>
    .thumbnail {
        &__foreground-logo {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 997;
            filter: drop-shadow(2px 2px 8px #FFFFFFBF);
        }
    }
</style>
